import { BaseUrl } from '../ApiUrl'
import AXIOS_SERVICE from '../../utils/AxiosUtil'

const TicketReportService = () => {}

TicketReportService.GetTicketReport = async(queryString)=> {  
  return await AXIOS_SERVICE('get', `${BaseUrl}/report/ticket?${queryString}`, {})
}

export default TicketReportService